export default [
    'onReady',
    'onStateChange',
    'onPlaybackQualityChange',
    'onPlaybackRateChange',
    'onError',
    'onApiChange',
];